import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as sustainabilitySettingsActions from '../store/actions/farm-settings.actions';

@Injectable()
export class FarmSettingsResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    this.store.dispatch(sustainabilitySettingsActions.loadFarmSettings());
    return of(true);
  }
}
